import { Form } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import RadioButton from 'components/Form/RadioButton'
import Label from 'components/Label/Label'
import FileReaderVisible from 'components/Uploader/FileReaderVisible'
import Uploadloader from 'components/Uploader/Uploader'
import { setResumeData } from 'modules/Onboarding/actions'
import {
  FooterFlex,
  FormItem,
  Heading,
  RadioGroup,
  StyledDrawer,
  SubHeading,
} from 'modules/Resume/DrawerComponents/DrawerStyle'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'

const ProofDocuments = ({
  drawerStatus,
  setdrawerStatus,
  updateStudentData,
  studentFormData,
}) => {
  const [form] = Form.useForm()
  const dispatch = new useDispatch()
  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(true)

  // const studentFormData = useSelector(
  //     state => state?.studentData?.studentEditData
  //   )
  const [idProofFile, setIdProofFile] = useState(null)
  const [addressProofFile, setAddressProofFile] = useState(null)
  const [idProof, setIdProof] = useState(
    studentFormData?.studentPersonalProfile?.idProof[0]?.document ||
      'driving_licence'
  )
  const [addressProof, setAddressProof] = useState(
    studentFormData?.studentPersonalProfile?.addressProof[0]?.document ||
      'pan_card'
  )
  const [aadharProofFront, setAadharProofFront] = useState(null)
  const [aadharProofBack, setAadharProofBack] = useState(null)

  useEffect(() => {
    let idProofData = studentFormData?.studentPersonalProfile?.idProof
    let addressProofData = studentFormData?.studentPersonalProfile?.addressProof

    setIdProof(idProofData[0]?.document || 'driving_licence')
    setAddressProof(addressProofData[0]?.document || 'pan_card')

    const getAadharData = list => {
      list[0]?.name?.includes('front') && setAadharProofFront(list[0])
      list[1]?.name?.includes('back') && setAadharProofBack(list[1])
    }

    if (idProofData[0]?.document === 'aadhaar_card') {
      getAadharData(idProofData)
    } else {
      setIdProofFile(idProofData[0])
    }

    if (addressProofData[0]?.document === 'aadhaar_card') {
      getAadharData(addressProofData)
    } else {
      setAddressProofFile(addressProofData[0])
    }
  }, [studentFormData])

  useEffect(() => {
    const getObject = (document, file) => {
      if (document === 'aadhaar_card') {
        return {
          document: document,
          aadhar_front_url: aadharProofFront?.url,
          aadhar_back_url: aadharProofBack?.url,
        }
      } else {
        return {
          document: document,
          url: file?.url,
        }
      }
    }

    form.setFieldsValue({
      idProof: getObject(idProof, idProofFile),
      addressProof: getObject(addressProof, addressProofFile),
    })
  }, [idProofFile, addressProofFile, addressProof, idProof])

  const onChangeIdProof = value => {
    setIsUpdateButtonEnabled(false)
    setIdProof(value?.target?.value)
    setIdProofFile(null)
    if (addressProof !== 'aadhaar_card') {
      setAadharProofFront(null)
      setAadharProofBack(null)
    }
  }

  const onChangeAddressProof = value => {
    setIsUpdateButtonEnabled(false)
    setAddressProof(value?.target?.value)
    setAddressProofFile(null)
    if (idProof !== 'aadhaar_card') {
      setAadharProofFront(null)
      setAadharProofBack(null)
    }
  }

  const getUploader = (formName, feildName, file, setFile, fileNmae) => {
    return (
      <FormItem name={[[formName], [feildName]]}>
        {file ? (
          <Control column top="20px" center>
            <FileReaderVisible
              file={file}
              setFile={setFile}
              setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
            />
          </Control>
        ) : (
          <Control column top="20px" center>
            <Uploadloader
              setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
              setFile={setFile}
              isDefault={true}
              fileName={fileNmae}
            />
          </Control>
        )}
      </FormItem>
    )
  }

  const getAdharUploader = (formName, fileName) => {
    return (
      <Fragment>
        <Label marginBottom={'0px'} marginTop={'14px'}>
          Front
        </Label>
        {getUploader(
          formName,
          'aadhar_front_url',
          aadharProofFront,
          setAadharProofFront,
          fileName + '_front'
        )}

        <Label marginBottom={'0px'} marginTop={'14px'}>
          Back
        </Label>
        {getUploader(
          formName,
          'aadhar_back_url',
          aadharProofBack,
          setAadharProofBack,
          fileName + '_back'
        )}
      </Fragment>
    )
  }

  const submitHandler = async values => {
    let idProofList = []
    let addressPoofList = []
    if (idProof === 'aadhaar_card') {
      if (aadharProofFront != undefined)
        idProofList.push({ ...aadharProofFront, document: idProof })
      if (aadharProofBack != undefined)
        idProofList.push({ ...aadharProofBack, document: idProof })
    } else if (idProofFile != undefined)
      idProofList.push({ ...idProofFile, document: idProof })

    if (addressProof === 'aadhaar_card') {
      if (aadharProofFront != undefined)
        addressPoofList.push({ ...aadharProofFront, document: addressProof })
      if (aadharProofBack != undefined)
        addressPoofList.push({ ...aadharProofBack, document: addressProof })
    } else if (addressProofFile != undefined)
      addressPoofList.push({ ...addressProofFile, document: addressProof })

    let payload = {
      admin: {
        ...studentFormData?.admin,
        countryCode: studentFormData?.admin?.countryCode,
      },
      student: studentFormData?.student,
      degreeStreamMap: !studentFormData?.student?.isExpCandidate
        ? {
            degreeId: studentFormData?.currentCourse?.degreeId,
            streamId: studentFormData?.currentCourse?.streamId,
          }
        : {},
      studentPersonalProfile: {
        ...studentFormData?.studentPersonalProfile,
        idProof: idProofList,
        addressProof: addressPoofList,
      },
      currentCourse: !studentFormData?.student?.isExpCandidate
        ? studentFormData?.currentCourse
        : {},
      education: studentFormData?.education,
      resume: studentFormData?.resume,
    }
    if (payload?.currentCourse?.specialisationId === null) {
      delete payload?.currentCourse?.specialisationId
    }
    if (payload?.studentPersonalProfile?.secondaryEmail === null) {
      delete payload?.studentPersonalProfile?.secondaryEmail
    }
    if (payload?.currentCourse?.degreeStreamMapId === null) {
      delete payload?.currentCourse?.degreeStreamMapId
    }
    studentFormData?.education.map((item, index) => {
      if (item?.skills === null) delete payload?.education[index]?.skills
      if (item?.degreeStreamMapId === null)
        delete payload?.education[index]?.degreeStreamMapId
    })
    let response = await updateStudentData(payload)
    dispatch(setResumeData(payload))
    if (response?.success === true) {
      SuccessMessage('Documents saved successfully!')
      setdrawerStatus(false)
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }

  const content = () => {
    return (
      <Form
        scrollToFirstError
        onFinish={submitHandler}
        id={'documentForm'}
        form={form}
        layout="vertical"
      >
        <Control flexStart column>
          <Heading>ID Proof</Heading>
          <SubHeading>Choose the file type</SubHeading>
          <FormItem name={['idProof', 'document']}>
            <Control column top="20px">
              <RadioGroup value={idProof} onChange={onChangeIdProof}>
                <RadioButton
                  value={'driving_licence'}
                  label="Driving Licence"
                />
                <RadioButton
                  value={'aadhaar_card'}
                  label="Aadhaar Card"
                  disabled={addressProof === 'aadhaar_card'}
                />
              </RadioGroup>
            </Control>
          </FormItem>

          {idProof !== 'aadhaar_card'
            ? getUploader(
                'idProof',
                'url',
                idProofFile,
                setIdProofFile,
                idProof
              )
            : getAdharUploader('idProof', idProof)}
        </Control>
        <Control flexStart column top="25px">
          <Heading>Address Proof</Heading>
          <SubHeading>Choose the file type</SubHeading>
          <FormItem name={['addressProof', 'document']}>
            <Control column top="20px">
              <RadioGroup value={addressProof} onChange={onChangeAddressProof}>
                <RadioButton value={'pan_card'} label="PAN Card" />
                <RadioButton
                  value={'aadhaar_card'}
                  label="Aadhaar Card"
                  disabled={idProof === 'aadhaar_card'}
                />
                <RadioButton value={'passport'} label="Passport" />
              </RadioGroup>
            </Control>
          </FormItem>
          {addressProof !== 'aadhaar_card'
            ? getUploader(
                'addressProof',
                'url',
                addressProofFile,
                setAddressProofFile,
                addressProof
              )
            : getAdharUploader('addressProof', addressProof)}
        </Control>
      </Form>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setdrawerStatus(false)
          }}
        />
        <Button.Primary
          form={'documentForm'}
          htmlType="submit"
          text={'Update'}
          disabled={isUpdateButtonEnabled}
        />
      </FooterFlex>
    )
  }
  return (
    <StyledDrawer
      width="675px"
      title={'Documents'}
      placement="right"
      closable={true}
      onClose={() => setdrawerStatus(false)}
      visible={drawerStatus}
      content={content()}
      footer={footer()}
    />
  )
}

export default ProofDocuments
